import React from 'react';
import { SvgIcon } from '@material-ui/core';

const CaretDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 8 6">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.994342 5.5C0.728969 5.5 0.474606 5.39319 0.287863 5.20333C-0.0985797 4.81045 -0.0955522 4.17651 0.294625 3.78739L3.30028 0.789859C3.68781 0.40338 4.31219 0.40338 4.69972 0.789859L7.70537 3.78739C7.89392 3.97542 8 4.23155 8 4.49876C8 5.05173 7.55482 5.5 7.00566 5.5H0.994342Z"
      fill="#0D004D"
    />
  </SvgIcon>
);

export default CaretDownIcon;
